import { Col, Row, Tooltip } from "antd";
import { Button, Empty } from "antd-v5";
import React, { useState } from "react";
import EqButton from "../../custom/eqButton/EqButton";
import { getDefaultImage, imageType, ticksToMilliSeconds } from "../../shared/Common";
import "./SchoolDashboardInvitations.scss";
import { useTranslation } from "react-i18next";
import { CourseLessonOrderEnt } from "../../shared/general/IStudentUnpaidOrders";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { IEqUiEventInvite } from "../../shared/interfaces/IEqEventDto";

interface StudentEventInvite {
    id: string;
    firstName: string;
    lastName: string;
    userName: string;
    userImage: string;
    numberOfInvitations: number;
}

interface SchoolPendings {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
}



interface CourseRequests {
    firstLessonStartDate?: number;
    courseLessonOrder: CourseLessonOrderEnt;
}
interface CardProps {

    TrainingInvitratoin?: IEqUiEventInvite[];
    //courseRequests?: CourseRequests[];
    //onRejectProduct?: (arg: object) => void;
    //onAcceptSchoolInvite?: (arg: object) => void;
    //onRejectSchoolInvite?: (arg: object) => void;
    // TrainingInvitratoin?: StudentEventInvite[];
    onAcceptTrainingInvitations?: (arg: object) => void;
    onRejectTrainingInvite?: (arg: object) => void;
    
    courseRequests?: CourseRequests[];
    onAcceptCourseRequestss?: (arg: object) => void;
    onRejectCourseInvite?: (arg: object) => void;

    onRejectProduct?: (arg: object) => void;
    onAcceptProduct?: (arg: object) => void;
}

const SchoolDashboardInvitations: React.FC<CardProps> = (
    {
        TrainingInvitratoin,
        onAcceptTrainingInvitations,
        onRejectTrainingInvite,
        
        courseRequests,
        onAcceptCourseRequestss,
        onRejectCourseInvite,
    }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState<string>("Training");
    const [showAllTraining, setShowAllTraining] = useState(false);
    const [showAllCourse, setShowAllCourse] = useState(false);

    const displayCourse = showAllCourse ? courseRequests : courseRequests?.slice(0, 4);
    const allEventsWithOrganizer = TrainingInvitratoin?.flatMap((invitation) =>
        invitation.events.map((event) => ({ ...event, organizer: invitation.organizer }))
    ) || [];
    const displayedTraining = showAllTraining ? allEventsWithOrganizer : allEventsWithOrganizer.slice(0, 3);

    return (
        <div className="school-invitations-card">
            <div className="card-header">
                <h3>{t("invitations")}</h3> 
            </div>
            <Row className="card-tab">
                <Col
                    className={`training-tab ${selectedTab === "Training" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("Training")}
                >
                    {t("trainingRequests")}
                </Col>
                <Col
                    className={`training-tab ${selectedTab === "Course" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("Course")}
                >
                    {t("courseRequests")}
                </Col>
                {/* <Col
                    className={`training-tab ${selectedTab === "School" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("School")}
                >
                    {t("School Invitations")}
                </Col> */}
            </Row>

            <div className="card-body">
                {selectedTab === "Training" ? (
                    <>
                        {TrainingInvitratoin && TrainingInvitratoin.length > 0 ? (
                            <>
                                {displayedTraining.length > 0 && (
                                    <>
                                        {displayedTraining.map((event) => (
                                            <div>
                                                <Row justify="space-between" style={{ alignItems: "center" }}>
                                                <Tooltip placement="topLeft" title={event.event.title}>
                                                   
                                                    <Col span={20}>
                                                        <Row style={{ alignItems: "center" }}>
                                                            <Col>
                                                                <div className="cover-div">
                                                                    <img
                                                                        src={event.user?.userImage?.url || getDefaultImage(imageType.events)}
                                                                        alt="Sender"
                                                                        className="product-image"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col>
                                                                <div className="invitation-title">{event.user.firstName} {event.user.lastName}</div>
                                                                <div>{new Date(event.event?.startTime).toLocaleString()}</div>

                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    </Tooltip>
                                                    <Col span={4} className="action-col">
                                                       
                                                        <Button
              onClick={() =>onAcceptTrainingInvitations &&  onAcceptTrainingInvitations(event)}
              className="invite-accept-btn"
              size="small"
              shape="circle"
              icon={<CheckOutlined />}
            />
            <Button
              onClick={() =>onRejectTrainingInvite &&  onRejectTrainingInvite(event)}
              className="invite-reject-btn"
              size="small"
              shape="circle"
              icon={<CloseOutlined />}
            />
                                                   
                                                   </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </>
                                )}

                                {(TrainingInvitratoin?.reduce((acc: any, invitation: any) => acc + (invitation.events?.length || 0), 0) > 3) && (
                                    <h3 className="showAll-click" onClick={() => setShowAllTraining(!showAllTraining)}>
                                        {showAllTraining ? t("showLess") : t("showAll")}
                                    </h3>
                                )}
                            </>
                        ) : (
                            <Empty description={t("noDataAvailable")}></Empty>
                        )}
                    </>
                ) : selectedTab === "Course" ? (
                    courseRequests && courseRequests.length > 0 ? (
                        <>
                            <div className="connection-section">
                                <div className="divider-line"></div>
                                {displayCourse?.map((item) => (
                                    <div key={item.courseLessonOrder.id} className="invitation-item">
                                        <Row justify="space-between" style={{ alignItems: "center" }}>
                                        <Tooltip placement="topLeft" title={item.courseLessonOrder.orderType === 0
                                                                ? item?.courseLessonOrder?.course?.title
                                                                : item.courseLessonOrder.courseLesson?.course?.title}>
                                                  
                                            <Col  span={22}>
                                     
                                                <Row style={{ alignItems: "center" }}>
                                                    <Col>
                                                        <div className="cover-div">
                                                            {item.courseLessonOrder.orderType === 0 ? (
                                                                <img
                                                                    src={item?.courseLessonOrder?.course?.image?.url || getDefaultImage(imageType.events)}
                                                                    alt="Course"
                                                                    className="product-image"
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={item.courseLessonOrder.courseLesson?.course?.image?.url || getDefaultImage(imageType.events)}
                                                                    alt="Course"
                                                                    className="product-image"
                                                                />
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="invitation-title">
                                                            {item.courseLessonOrder.student.firstName} {item.courseLessonOrder.student.lastName}
                                                        </div>
                                                        <div>{new Date( ticksToMilliSeconds(item?.courseLessonOrder?.orderType === 0
                                                                ?  item?.courseLessonOrder?.course?.startDate as number
                                                                : item?.courseLessonOrder?.courseLesson?.startTime as number)).toLocaleString()}</div>
                                                      
                                                    </Col>
                                                </Row>
                                            </Col>
                                            </Tooltip>
                                            <Col span={2} className="action-col">
                                                <EqButton onClick={() =>  navigate(`/school/trainingCourse?id=${item.courseLessonOrder.orderType === 0
                                                                ? item?.courseLessonOrder?.course?.id
                                                                : item.courseLessonOrder.courseLesson?.course?.id}`+`&orderId=${item.courseLessonOrder.id}`)}>
                                                    {t("view")}
                                                </EqButton>
                                                {/* <EqButton onClick={() => onRejectCourseInvite && onRejectCourseInvite(item)}>
                                                    {t("reject")}
                                                </EqButton> */}
                                            </Col>
                                        </Row>
                                        
                                    </div>
                                ))}
                            </div>
                            {courseRequests.length > 4 && (
                                <h3 className="showAll-click" onClick={() => setShowAllCourse(!showAllCourse)}>
                                    {showAllCourse ? t("showLess") : t("showAll")}
                                </h3>
                            )}
                        </>
                    ) : (
                        <Empty description={t("noDataAvailable")}></Empty>
                    )
                ) : (
                    <Empty description={t("noDataAvailable")}></Empty>
                )}
            </div>
        </div>
    );
};

export default SchoolDashboardInvitations;